
import {Options, Vue} from 'vue-class-component';
import './../less/elements/contactForm.less';
import {ErrorMessage, Field, Form} from 'vee-validate';
import * as yup from 'yup';
import axios from 'axios';

@Options({
    components: {
        Form,
        Field,
        ErrorMessage
    },
    props: {
        isLifetimeAwards: String
    },
    watch: {
        isLifetimeAwards(val) {
            this._isLifetimeAwards = val;
        },
        motivation(val) {
            if (val) {
                this.motivation = val.substring(0, 500);
                this.counter = val.length
            }
        }
    }
})
export default class RegistrationForm extends Vue {
    public manager = '';
    public contact_name = '';
    public contact_email = '';
    public motivation = '';
    public counter = 0;
    public contact_phone = '';
    public legal_statement = false;
    private _isLifetimeAwards = false;
    public is_company = false;
    public is_manager = false;
    public selectedAwards = [];
    public selectedCompany: any = null;
    public isSent = false;
    public isSending = false;
    public isLoading = false;
    public schema = yup.object({
        is_manager: yup.lazy((value: any) => {
            if (this.is_company || this.is_manager) {
                return yup.mixed().notRequired();
            } else {
                return yup.object({
                    is_manager: yup.bool().oneOf([true], 'Field must be checked'),
                })
            }
        }),
        is_company: yup.lazy((value: any) => {
            if (this.is_company || this.is_manager) {
                return yup.mixed().notRequired();
            } else {
                return yup.object({
                    is_company: yup.bool().oneOf([true], 'Field must be checked'),
                })
            }
        }),
        manager: yup.lazy((value: any) => {
            if (this.is_manager) {
                return yup.string().required();
            } else {
                return yup.mixed().notRequired();
            }
        }),
        selectedCompany: yup.lazy((value: any) => {
            if (this.is_company) {
                return yup.object().nullable(false);
            } else {
                return yup.mixed().notRequired();
            }
        }),
        contact_email: yup.string().required().email(),
        contact_name: yup.string().required(),
        selectedAwards: yup.array().min(1, 'too short').required('it is required'),
        terms: yup.bool().oneOf([true], 'Field must be checked'),
    });


    mounted() {
        this.getAwardsData()
    }

    get isLifetimeAwards() {
        return this._isLifetimeAwards;
    }


    interval: any
    company = []

    awards = []

    send() {
        if (!this.isSending) {
            this.isSending = true
            const formData = new FormData()
            formData.append('is_company', this.is_company ? '1' : '0')
            formData.append('is_manager', this.is_manager ? '1' : '0')
            this.selectedAwards.forEach((award: any) => {
                formData.append('awards[]', award.id)
            })
            if (this.is_company) {
                console.log(this.selectedCompany)
                formData.append('company', this.selectedCompany.Name)
            }
            if (this.is_manager) {
                formData.append('manager', this.manager)
            }
            formData.append('contact_name', this.contact_name)
            formData.append('contact_email', this.contact_email)
            formData.append('contact_phone', this.contact_phone)
            formData.append('motivation', this.motivation)
            formData.append('is_legal_statement_accepted', this.legal_statement ? '1' : '0')
            axios.post('/api/v1/hbaapplications', formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(() => {
                this.isSent = true
                this.resetForm();
                this.isSending = false

            }).catch(() => {
                this.isSending = false

            })
        }
    }

    resetForm() {

        this.manager = '';
        this.contact_email = '';
        this.motivation = '';
        this.legal_statement = false;
    }

    back() {
        this.resetForm();
        this.isSent = false
    }

    getAwardsData() {
        axios.get('/api/v1/awards').then((data) => {
            if (data?.data?.data.length > 0) {
                if (this.isLifetimeAwards) {
                    this.awards = data.data.data.filter((award) => {
                        return award.is_business_life_award
                    })
                } else {
                    this.awards = data.data.data
                }
                if (this.awards.length == 1) {
                    this.selectedAwards.push(this.awards[0]);
                }
            }
        })
    }

    fetchOptions(search, loading) {
        this.isLoading = true
        clearTimeout(this.interval)
        if (search && search.length > 2) {
            this.interval = setTimeout(() => {
                this.getCompanyData(search)
            }, 500)
        }
    }

    getCompanyData(company: string) {
        axios.get('api/v1/opten/search?companyName=' + company).then((data) => {
            console.log(data)
            console.log(data.data.companies)
            if (data?.data?.companies.length > 0) {
                this.company = data.data.companies
            }
            this.isLoading = false
        }).catch((error) => {
            this.isLoading = false
        })
    }

    get getIsLoading() {
        return this.isLoading
    }


}
